<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG_GRP_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="categoryName"
              maxlength="100"
              :disabled="false"
              :readonly="false"
              @input="specialChar(categoryName)"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="datePicker"
              v-model="rangeDate"
              :value="rangeDate"
            />
          </div>
        </div>
        <div class="btn_wrap">
            <sui-button
              type="button"
              class="comm_btn_Reset"
              @click="onResetClick"
            >
              {{ $t('MSG_BTN_RESET') }}
            </sui-button>
            <sui-button
              v-permission:read="contextPageId"
              type="button"
              class="comm_btn_Scr"
              @click="onSearchClick"
            >
              {{ $t('MSG_BTN_SEARCH') }}
            </sui-button>
          </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="gridCategory"
        :columns="gridColumns0"
        :initial-pagesize="10"
        :showCountControl="true"
        :showDisplayCountControl="true"
        :dataset="'dataset0'"
        :multiselect="false"
        @rowclick="onSelectRow"
      />
      <div class="comm_btnBot_wrap">
        <div class="btn_wrapL" />
        <div class="btn_wrapR">
          <sui-button
            v-if="showBulletinAdmin"
            v-permission:update="contextPageId"
            type="button"
            class="comm_btn_border"
            :disabled="modifyDisabled"
            @click="onModifyClick"
          >
            {{ $t('MSG_BTN_MDFC') }}
          </sui-button>
          <sui-button
            v-if="showBulletinAdmin"
            v-permission:delete="contextPageId"
            type="button"
            class="comm_btn_border"
            :disabled="deleteDisabled"
            @click="onDeleteClick"
          >
            {{ $t('MSG_BTN_DEL') }}
          </sui-button>
          <sui-button
            v-if="showBulletinAdmin"
            v-permission:create="contextPageId"
            type="button"
            class="comm_btn_solid"
            :disabled="registerStatus"
            @click="onRegistClick"
          >
            {{ $t('MSG_BTN_RGST') }}
          </sui-button>
        </div>
      </div>
      <sui-popup
        v-model="showDetailPopup"
        :title="$t('MSG_TIT_CATG_GRP_DTL_POPUP')"
      >
        <p03
          :biddingInformationParam="biddingInformationParam"
          :parentPageId="contextPageId"
          @exit="onPopupCancelClicked('detail')"
        />
      </sui-popup>
      <sui-popup
        v-model="showModPopup"
        :title="$t('MSG_TIT_CATG_GRP_MDFC_POPUP')"
      >
        <p02
          :biddingInformationParam="biddingInformationParam"
          :parentPageId="contextPageId"
          @exit="onPopupCancelClicked"
        />
      </sui-popup>
      <sui-popup
        v-model="showRegisterPopup"
        :title="$t('MSG_TIT_CATG_GRP_RGST_POPUP')"
      >
        <p01
          :biddingInformationParam="biddingInformationParam"
          :parentPageId="contextPageId"
          @exit="onPopupCancelClicked"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';
import p03 from './components/PGE_CLB_00007_P03';
import p02 from './components/PGE_CLB_00007_P02';
import p01 from './components/PGE_CLB_00007_P01';

export default {
  name: 'PGE_CLB_00007', // eslint-disable-line vue/name-property-casing
  components: {
    p02,
    p03,
    p01,
  },
  extends: BasePage,
  data() {
    return {
      categoryName: '',
      modifyDisabled: true,
      registerStatus: false,
      deleteDisabled: true,
      showRegisterPopup: false,
      showModPopup: false,
      showDetailPopup: false,
      rangeDate: {
        from: '',
        to: '',
      },
      showBulletinAdmin: false,
    };
  },
  computed: {},
  watch: {},
  datasets: [
    {
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [
        {
          name: 'bullBoardCategoryGroupName',
          type: 'string',
          map: 'bullBoardCategoryGroupName',
        },
        {
          name: 'userGlobalName',
          type: 'string',
          map: 'userGlobalName',
        },
        {
          name: 'firstRegistrationDTM',
          type: 'string',
          map: 'firstRegistrationDTM',
        },
        {
          name: 'bullBoardCategoryGroupID',
          type: 'string',
          map: 'bullBoardCategoryGroupID',
        },
        {
          name: 'loginId',
          type: 'string',
          map: 'loginId',
        },
      ],
    },
  ],
  created() {
    this.localdata0 = [];
    this.gridColumns0 = [
      {
        text: this.$t('MSG_TXT_CATG_GRP_NM'),
        datafield: 'bullBoardCategoryGroupName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onClickGrid,
            type: 'link',
          },
          this.dataset0, this.$refs.gridCategory);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_RGST_USR'),
        datafield: 'userGlobalName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            loginId: 'loginId',
          },
          this.dataset0, this.$refs.gridCategory);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_RGST_DTM'),
        datafield: 'firstRegistrationDTM',
      },
    ];
    this.biddingInformationParam = [];
  },
  mounted() {
    this.getSession();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    specialChar(value) {
      if (utils.isExistSpecialChar(value)) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_SPECL_CHAR'), null, () => {
          this.categoryName = '';
        });
      }
    },
    onPopupCancelClicked(option) {
      switch (option) {
        case 'detail':
          this.showDetailPopup = false;
          break;
        case 'cancelRegister':
          this.showRegisterPopup = false;
          break;
        case 'register':
          this.showRegisterPopup = false;
          this.onSearchClick();
          break;
        case 'modify':
          this.showModPopup = false;
          this.onSearchClick();
          break;
        case 'cancelModify':
          this.showModPopup = false;
          break;
        default:
          break;
      }
    },
    getSession() {
      this.sessionInfo = this.$store.getters.userInfo;
      const roleListArray = this.sessionInfo.roleList;
      const ifRoleExist = roleListArray.some(
        el => el.roleNickName === 'BBS_ADMIN',
      );
      if (!ifRoleExist) {
        this.showBulletinAdmin = true;
      }
    },
    onRegistClick() {
      this.showRegisterPopup = true;
    },
    onModifyClick() {
      const selectedIndex = this.dataset0.getSelectedIndexes();
      const categoryId = this.dataset0.data[selectedIndex].bullBoardCategoryGroupID;
      this.biddingInformationParam = [];
      const pathParam = {
        'category-group-id': categoryId,
      };
      http.request(this.contextPageId, 'DTS_CLB_00037', {
        path: pathParam,
      }).then(res => {
        this.biddingInformationParam = res.data;
        this.showModPopup = true;
      });
    },
    onDeleteClick() {
      utils.messageBox('confirm', this.$t('MSG_ALT_IS_DEL_DATA'), null, this.deleteAction);
    },
    deleteAction() {
      const selectedIndex = this.dataset0.getSelectedIndexes();
      const categoryGroupId = this.dataset0.data[selectedIndex].bullBoardCategoryGroupID;
      http.request(this.contextPageId, 'DTS_CLB_00057', {
        path: {
          'category-group-id': categoryGroupId,
        },
      }).then(res => {
        if (res.data.resultCode === '1') {
          utils.messageBox('error', this.$t('MSG_ALT_REL_CATG_POSTING'), null);
        } else {
          http.request(this.contextPageId, 'DTS_CLB_00039', {
            path: {
              'category-group-id': categoryGroupId,
            },
          }).then(res => {
            if (res.data.resultCode === '1') {
              utils.messageBox('success', this.$t('MSG_ALT_PRGS_OK'), null);
              this.onSearchClick();
            }
          });
        }
      });
    },
    onSelectRow(event) {
      const { rowindex } = event.args;
      this.dataset0.setSelectedIndex(rowindex);
      this.deleteDisabled = false;
      this.modifyDisabled = false;
    },
    onClickGrid(btn, dataRow) {
      const categoryId = dataRow.bullBoardCategoryGroupID;
      this.biddingInformationParam = [];
      const pathParam = {
        'category-group-id': categoryId,
      };
      http.request(this.contextPageId, 'DTS_CLB_00037', {
        path: pathParam,
      }).then(res => {
        this.biddingInformationParam = res.data;
        this.showDetailPopup = true;
      });
    },
    onSearchClick() {
      this.modifyDisabled = true;
      this.deleteDisabled = true;
      const queryParams = {
        categoryGroupName: this.categoryName,
        startDate: utils.dateformatToServer(this.rangeDate.from),
        endDate: utils.dateformatToServer(this.rangeDate.to).substr(0, 8).concat('235959'),
      };
      http.request(this.contextPageId, 'DTS_CLB_00033', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, 'firstRegistrationDTM');
        this.dataset0.setRawData(res.data);
      });
    },
    onResetClick() {
      this.categoryName = '';
      this.rangeDate = { from: '', to: '' };
    },
  },
};
</script>
<style scoped>
</style>
